import {getRolesPantalla} from '@/utils/funtionsGlobals';


const ParametrosSistemaView = () =>
  import('../views/configuracion/parametros-sistema/ParametrosSistemaView.vue');

export default [
  {
    path: '/MtoParametrosSistemaView',
    name: 'MtoParametrosSistemaView',
    component: ParametrosSistemaView,
    meta: {
      title: 'Buscador Parámetros Sistema',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoParametrosSistemaView'),
      bread: {
        path: [
          'Configuración',
        ],
      },
    },
  },
];
